import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

export const LOAN_STATUSES_NON_ACTIVE_FOR_DETAIL_ACTIONS = [
  LoanStatus.STATUS_EXPIRED,
  LoanStatus.STATUS_CANCELLED,
  LoanStatus.STATUS_CANCELLED_TEST,
  LoanStatus.STATUS_DESISTED,
  LoanStatus.STATUS_ACTIVE,
  LoanStatus.STATUS_ACTIVE_TRIAL,
  LoanStatus.STATUS_UNPAID,
  LoanStatus.STATUS_ENDED,
];

export const ALLOWED_LOAN_STATUSES_FOR_CANCELLED = [
  LoanStatus.STATUS_DESISTED,
  LoanStatus.STATUS_INITIAL,
  LoanStatus.STATUS_ANALYSING,
  LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED,
  LoanStatus.STATUS_CONTRACT_SIGNED,
  LoanStatus.STATUS_DOCS_APPROVED,
  LoanStatus.STATUS_ACTIVE_TRIAL,
  LoanStatus.STATUS_ACTIVE,
  LoanStatus.STATUS_CANCELLED_TEST,
];

export const ALLOWED_LOAN_STATUSES_FOR_CANCELLED_MERCHANT = [
  LoanStatus.STATUS_DESISTED,
  LoanStatus.STATUS_INITIAL,
  LoanStatus.STATUS_ANALYSING,
  LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED,
  LoanStatus.STATUS_CONTRACT_SIGNED,
  LoanStatus.STATUS_CANCELLED_TEST,
];

export const ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST = [
  LoanStatus.STATUS_DESISTED,
  LoanStatus.STATUS_INITIAL,
  LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED,
  LoanStatus.STATUS_CANCELLED,
  LoanStatus.STATUS_ANALYSING,
  LoanStatus.STATUS_DENIED,
  LoanStatus.STATUS_EXPIRED,
  LoanStatus.STATUS_CONTRACT_SIGNED,
  LoanStatus.STATUS_DOCS_APPROVED,
];

export const ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST_MERCHANT = [
  LoanStatus.STATUS_DESISTED,
  LoanStatus.STATUS_INITIAL,
  LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED,
  LoanStatus.STATUS_CANCELLED,
  LoanStatus.STATUS_ANALYSING,
  LoanStatus.STATUS_DENIED,
  LoanStatus.STATUS_EXPIRED,
  LoanStatus.STATUS_CONTRACT_SIGNED,
];

export const ALLOWED_LOAN_STATUSES_EXTERNAL_FOR_REFUND = [
  LoanStatusExternal.CONFIRMED,
  LoanStatusExternal.CAPTURED,
  LoanStatusExternal.PAID,
];
